export enum SystemUserAccessRole {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  VERIFIER = 3,
}

export const SystemUserAccessRoleValues: Record<SystemUserAccessRole, string> =
  {
    [SystemUserAccessRole.SUPER_ADMIN]: "Super Admin",
    [SystemUserAccessRole.ADMIN]: "Admin",
    [SystemUserAccessRole.VERIFIER]: "Verifier",
  };

export const SystemUserAccessRoleOptions = [
  {
    value: String(SystemUserAccessRole.ADMIN),
    label: SystemUserAccessRoleValues[SystemUserAccessRole.ADMIN],
  },
  {
    value: String(SystemUserAccessRole.VERIFIER),
    label: SystemUserAccessRoleValues[SystemUserAccessRole.VERIFIER],
  },
];

/** Limited Admin may only create Verifier users */
export const VerifierOnlyAccessRoleOptions = [
  {
    value: String(SystemUserAccessRole.VERIFIER),
    label: SystemUserAccessRoleValues[SystemUserAccessRole.VERIFIER],
  },
];

export const getCreatableAccessRoleOptions = (
  canManagePlatformAdmins: boolean,
) =>
  canManagePlatformAdmins
    ? SystemUserAccessRoleOptions
    : VerifierOnlyAccessRoleOptions;
